/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Te_Effect_ImprovingInputs */

const en_ui_te_effect_improving = /** @type {(inputs: Ui_Te_Effect_ImprovingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Improving`)
};

const de_ui_te_effect_improving = /** @type {(inputs: Ui_Te_Effect_ImprovingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verbessernd`)
};

/**
* | output |
* | --- |
* | "Improving" |
*
* @param {Ui_Te_Effect_ImprovingInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_te_effect_improving = /** @type {((inputs?: Ui_Te_Effect_ImprovingInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Te_Effect_ImprovingInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_te_effect_improving(inputs)
	return de_ui_te_effect_improving(inputs)
});